/** Solo acepta una ruta interna (`/…`): rechaza protocolo-relativas (`//`, `/\`), URLs absolutas y `/login`. */

const PARAM = 'next'
const RUTA_LOGIN = /^\/login(?:[/?]|$)/

export function rutaSegura(valor: string | null | undefined): string {
  if (!valor || !valor.startsWith('/') || valor.startsWith('//') || valor.startsWith('/\\') || RUTA_LOGIN.test(valor))
    return '/'
  return valor
}

/** `destino` es `/login`; sin ruta que recordar (ya en `/`), el enlace queda limpio. */
export function conRetorno(destino: string, rutaActual: string): string {
  if (rutaActual === '/' || rutaActual === '') return destino
  return `${destino}?${PARAM}=${encodeURIComponent(rutaActual)}`
}

export function rutaDeRetorno(search: string): string {
  return rutaSegura(new URLSearchParams(search).get(PARAM))
}
